export default "__VITE_ASSET__8298cff2__"